import { v4 as uuidv4 } from "uuid";
import { writeData } from "../../../api";
import { insertPageBlock } from "../../../api/page";
import { PushConnectorBlock } from "../../../types/notebook/note/block/pushConnector";
import { pushConFormDataToObject } from "../../../types/pushConnector";
import { useAppIdMap } from "../../app";
import { useAddPushConnectors } from "../../pushConnector";
import { useInsertBlock } from "../block";
import { useSelectedNotebookPageIdMap } from "../../page";

export const useInsertPushConnectorBlock = () => {
  const { selectedNotebookPageId } = useSelectedNotebookPageIdMap();
  const { appId } = useAppIdMap();
  const insertBlock = useInsertBlock();
  const addPushConnectors = useAddPushConnectors();

  return async (config: { blockIndex: number }) => {
    const { blockIndex } = config;
    const pushCon = pushConFormDataToObject({
      formData: {
        name: "Credential",
        description: "Credential",
        prompt: "Prompt For LLM",
      },
      appId: appId!,
    });
    const block: PushConnectorBlock = {
      "block-id": uuidv4(),
      "app-id": appId!,
      "push-con-id": pushCon["push-con-id"],
      type: "omega/query-omega/page/block/push-connector/PushConnectorBlock",
      "page-id": selectedNotebookPageId!,
    };
    addPushConnectors([pushCon]);
    insertBlock({ block, blockIndex });
    await writeData(pushCon);
    await insertPageBlock({ block, "block-index": blockIndex });
    return block;
  };
};
